module.exports = __webpack_public_path__ + "static/media/Ornn_0.ccfa1a2b.jpg";